import { Validator, AbstractControl, NG_VALIDATORS, ValidatorFn } from '@angular/forms';
import { Directive, Input } from '@angular/core';
import { LinehaulScheduleFormFields } from '../enums/linehaul-schedule-form-fields.enum';
import { ErrorWarningService } from '../components/payform/services/error-warning/error-warning.service';
import { WarningValidationType } from '../enums';
import { FormUtils } from '../classes';
import { LoDash } from '../utils/angular-utils/lodash-utils';

export function cushionValidatorFunction(errorWarningService: ErrorWarningService, schSequenceNbr: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control || control.disabled || !control.parent || !errorWarningService.shouldDisplayWarnings()) {
      return null;
    }

    if (!control.value && FormUtils.hasWarning(control, undefined, WarningValidationType.CushionWarning)) {
      FormUtils.unsetWarning(control, WarningValidationType.CushionWarning);
      errorWarningService.detailWarningsChanged(schSequenceNbr);
    }

    if (control.value) {
      const origin: string = LoDash.get(control.parent.get(LinehaulScheduleFormFields.OriginSicCd), 'value', '');
      const dest: string = LoDash.get(control.parent.get(LinehaulScheduleFormFields.DestinationSicCd), 'value', '');
      const cushionWarning = {
        type: WarningValidationType.CushionWarning,
        primarySubject: `${origin.toUpperCase()} -> ${dest.toUpperCase()}`,
      };
      FormUtils.setWarning(control, WarningValidationType.CushionWarning, cushionWarning);
      errorWarningService.detailWarningsChanged(schSequenceNbr);
    }

    return null;
  };
}

@Directive({
  selector: '[cushionValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: CushionValidator, multi: true }],
})
export class CushionValidator implements Validator {
  constructor(private errorWarningService: ErrorWarningService) {}
  @Input()
  schSequenceNbr: string;

  validate(control: AbstractControl): { [key: string]: any } | null {
    return cushionValidatorFunction(this.errorWarningService, this.schSequenceNbr)(control);
  }
}
